import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatMenuModule } from "@angular/material/menu";
import { EventParticipant } from "@models/event-participants";
import { Page } from "@models/page";
import { PaginatorModule, PaginatorState } from "primeng/paginator";
import { SkeletonModule } from "primeng/skeleton";
import { TableModule } from "primeng/table";
import { PaymentMethodPipe } from "../../../../shared/pipes/payment-method.pipe";
import { PaymentStatusPipe } from "../../../../shared/pipes/payment-status.pipe";
import { SalesChannelPipe } from "@shared/pipes/sales-channel.pipe";

export type ParticipantsSortField =
  | "order_number"
  | "name"
  | "email"
  | "total_amount"
  | "payment_method"
  | "date_time_order"
  | "status";

@Component({
  selector: "app-participants-table",
  imports: [
    CommonModule,
    TableModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    PaymentMethodPipe,
    PaymentStatusPipe,
    SalesChannelPipe,
    PaginatorModule,
    SkeletonModule,
  ],
  templateUrl: "./participants-table.component.html",
  styleUrl: "./participants-table.component.scss",
})
export class ParticipantsTableComponent {
  @Input() first = 0;
  @Input() rows = 10;
  @Input({ required: true }) data: Page<EventParticipant> | null = null;
  @Input() sort: ParticipantsSortField | null = null;
  @Input() direction: "asc" | "desc" = "desc";

  @Output() detailOrderClick = new EventEmitter<EventParticipant>();
  @Output() pageChange = new EventEmitter<PaginatorState>();
  @Output() sortChange = new EventEmitter<ParticipantsSortField>();

  customerName(row: EventParticipant): string {
    const pdv = row.sales_channel === "pdv";
    const parts = pdv
      ? [row.pdv_buyer?.name, row.pdv_buyer?.last_name]
      : [row.user_name, row.user_last_name];
    return (
      parts
        .filter((part) => typeof part === "string" && part.trim())
        .map((part) => part!.trim())
        .join(" ") || (pdv ? "Ao portador" : "Não informado")
    );
  }

  customerEmail(row: EventParticipant): string {
    return (
      (row.sales_channel === "pdv"
        ? row.pdv_buyer?.email
        : row.user_email
      )?.trim() || "Não informado"
    );
  }

  customerTelephone(row: EventParticipant): string {
    return (
      (row.sales_channel === "pdv"
        ? row.pdv_buyer?.telephone
        : row.user_telephone
      )?.trim() || "Não informado"
    );
  }

  sortIcon(field: ParticipantsSortField): string {
    if (this.sort !== field) return "pi pi-sort-alt";
    return this.direction === "asc"
      ? "pi pi-sort-amount-up"
      : "pi pi-sort-amount-down";
  }
}
